export default __webpack_public_path__ + "static/media/1.0a56b4fc.png";